module.exports = __webpack_public_path__ + "static/climbers_kit-40d2afb9c7d99f612522f1421001e026.jpg";